import '@angular/compiler';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PortalQadatasetQasetComponent } from './portal.qadataset.qaset/portal.qadataset.qaset.component';
import { ComponentDashboardComponent } from './component.dashboard/component.dashboard.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PortalQadatasetReviewlogComponent } from './portal.qadataset.reviewlog/portal.qadataset.reviewlog.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PortalQadatasetQainstructverifyComponent } from './portal.qadataset.qainstructverify/portal.qadataset.qainstructverify.component';
import { PortalDashboardAdmindashboardComponent } from './portal.dashboard.admindashboard/portal.dashboard.admindashboard.component';
import { PortalQadatasetVerifyComponent } from './portal.qadataset.verify/portal.qadataset.verify.component';
import { ComponentHeaderComponent } from './component.header/component.header.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { ComponentNavUserComponent } from './component.nav.user/component.nav.user.component';
import { ComponentFooterComponent } from './component.footer/component.footer.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageUipageComponent } from './page.uipage/page.uipage.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { ComponentPaginationComponent } from './component.pagination/component.pagination.component';
import { PortalQadatasetQainstructComponent } from './portal.qadataset.qainstruct/portal.qadataset.qainstruct.component';
import { PortalRawdataListComponent } from './portal.rawdata.list/portal.rawdata.list.component';
import { LayoutUserComponent } from './layout.user/layout.user.component';
import { PageAuthenticateComponent } from './page.authenticate/page.authenticate.component';
import { PortalAdminpageForadminComponent } from './portal.adminpage.foradmin/portal.adminpage.foradmin.component';
import { ComponentMypageComponent } from './component.mypage/component.mypage.component';
import { PortalRawdataDetailComponent } from './portal.rawdata.detail/portal.rawdata.detail.component';
import { PortalSeasonAlertComponent } from './portal.season.alert/portal.season.alert.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PortalDashboardUserdashboardComponent } from './portal.dashboard.userdashboard/portal.dashboard.userdashboard.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// import { CommonModule } from '@angular/common';
// import { PdfViewerModule } from 'ng2-pdf-viewer';

@NgModule({
    declarations: [
        AppComponent,
        PortalSeasonPaginationComponent,
        PortalQadatasetQasetComponent,
        ComponentDashboardComponent,
        PortalSeasonModalComponent,
        PortalQadatasetReviewlogComponent,
        PortalSeasonFormDropdownComponent,
        PortalQadatasetQainstructverifyComponent,
        PortalDashboardAdmindashboardComponent,
        PortalQadatasetVerifyComponent,
        ComponentHeaderComponent,
        LayoutEmptyComponent,
        ComponentNavUserComponent,
        ComponentFooterComponent,
        PortalSeasonLoadingSeasonComponent,
        PageUipageComponent,
        PortalSeasonTreeComponent,
        ComponentPaginationComponent,
        PortalQadatasetQainstructComponent,
        PortalRawdataListComponent,
        LayoutUserComponent,
        PageAuthenticateComponent,
        PortalAdminpageForadminComponent,
        ComponentMypageComponent,
        PortalRawdataDetailComponent,
        PortalSeasonAlertComponent,
        PortalSeasonLoadingDefaultComponent,
        PortalDashboardUserdashboardComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        // CommonModule,
        // PdfViewerModule, 
        
    ],
    providers: [],
    bootstrap: [AppComponent]
})
export class AppModule { }